export const VOD_DETAILS_PAGE_FOCUS_KEY = 'vodDetailsPage'
export const VOD_ROW_CONTAINER_FOCUS_KEY = 'vodContainer'
export const HOME_PAGE_FOCUS_KEY = 'homePage'
export const MENU_BUTTONS_FOCUS_KEY = 'MenuButtons'
export const READ_MORE_BUTTON_FOCUS_KEY = 'readMoreButton'
export const PLAY_BUTTON_FOCUS_KEY = 'playButton'
export const DIRECTION_UP_FOCUS_KEY = 'up'
export const DIRECTION_DOWN_FOCUS_KEY = 'down'
export const DIRECTION_LEFT_FOCUS_KEY = 'left'
export const DIRECTION_RIGHT_FOCUS_KEY = 'right'
export const VOD_PAGE_BACK_BUTTON_FOCUS_KEY = 'Vod Page backButton'
export const DETAILS_PAGE_BACK_BUTTON_FOCUS_KEY = 'Details page backButton'
export const ROW_ZERO_FOCUS_KEY = 'RowZero'
export const TOP_MENU_FOCUS_KEY = 'TopMenu'
export const SEARCH_INPUT_FOCUS_KEY = 'SearchInput'
